var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpirall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 258,
    viewBox: "0 0 568 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.6686C28.934 66.5259 78.6557 31.2442 137.925 15.2433C205.5 -2.99998 322.663 -16.0363 371.172 58.2008C395.132 94.8695 369.128 136.5 398 168.5C426.691 200.299 474.941 179.863 511.5 197C543.5 212 552 238.5 567 257",
    stroke: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpirall);
export default __webpack_public_path__ + "static/media/spirall.cf5cbee0d56df804514480df07fffd1a.svg";
export { ForwardRef as ReactComponent };